var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainfooter _mainfooter"},[_c('div',{staticClass:"footerbottom _footerbottom"},[_c('div',{staticClass:"scroll_top",on:{"click":_vm.backtop}},[_vm._v("返回顶部")]),_vm._v(" "),_c('p',[_vm._v("@聚利和 版权所有2009-2021  京ICP备12009157号-1 ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d2f36f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/comcomponents/Footer.vue
// module id = null
// module chunks = 